module.exports = __webpack_public_path__ + "img/grey-city.eb682ca4.jpg";